import { Cookies } from "react-cookie";
const cookies = new Cookies();

class CookiesServices {
  get(key) {
    return cookies.get(key);
  }
  set(key, value, options) {
    return cookies.set(key, value, options);
  }
  remove(key) {
    return cookies.remove(key);
  }
  destroy() {
    //  cookies.remove();
  }
}
const cookiesService = new CookiesServices();
export default cookiesService;
